export enum SMTPSecure {
    Tls = 'tls',
    Ssl = 'ssl',
}